<script setup lang="ts">
import { localize } from "@/utils";
import TabMenu from "@/components/TabMenu.vue";
import { IBaseMenuItem } from "@/models";

const props = defineProps({
  menuItems: { type: Array as () => IBaseMenuItem[], default: [] },
});
</script>

<template>
  <ul class="nav nav-tabs-fluid">
    <tab-menu :items="menuItems" />
  </ul>
  <div class="content">
    <div class="content-hd">
      <h3 class="fs-2">업력(이력) 정보 설정</h3>
      <p class="info-txt">허위 사실 기재로 인한 불이익에 대한 책임은 본인에게 있습니다.</p>
    </div>
    <div class="fieldset">
      <h4 class="fs-3">업력 정보</h4>
      <div class="flex-fill">
        <div class="history-wrap input-group">
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>년</span>
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>개월</span>
          <div class="flex-fill">
            <input type="text" class="form-control" value="2016년 하늘소기공 근무" placeholder="업력을 입력해주세요." />
            <button type="button" class="icon icon-x-circle">삭제</button>
          </div>
        </div>
        <div class="history-wrap input-group">
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>년</span>
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>개월</span>
          <div class="flex-fill">
            <input type="text" class="form-control" placeholder="업력을 입력해주세요." />
          </div>
        </div>
        <div class="history-wrap input-group">
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>년</span>
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>개월</span>
          <div class="flex-fill">
            <input type="text" class="form-control" placeholder="업력을 입력해주세요." />
          </div>
        </div>
        <div class="history-wrap input-group">
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>년</span>
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>개월</span>
          <div class="flex-fill">
            <input type="text" class="form-control" placeholder="업력을 입력해주세요." />
          </div>
        </div>
        <div class="history-wrap input-group">
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>년</span>
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>개월</span>
          <div class="flex-fill">
            <input type="text" class="form-control" placeholder="업력을 입력해주세요." />
          </div>
        </div>
        <div class="history-wrap input-group">
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>년</span>
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>개월</span>
          <div class="flex-fill">
            <input type="text" class="form-control" placeholder="업력을 입력해주세요." />
          </div>
        </div>
        <div class="history-wrap input-group">
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>년</span>
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>개월</span>
          <div class="flex-fill">
            <input type="text" class="form-control" placeholder="업력을 입력해주세요." />
          </div>
        </div>
        <div class="history-wrap input-group">
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>년</span>
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>개월</span>
          <div class="flex-fill">
            <input type="text" class="form-control" placeholder="업력을 입력해주세요." />
          </div>
        </div>
        <div class="history-wrap input-group">
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>년</span>
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>개월</span>
          <div class="flex-fill">
            <input type="text" class="form-control" placeholder="업력을 입력해주세요." />
          </div>
        </div>
        <div class="history-wrap input-group">
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>년</span>
          <select class="form-control form-select">
            <option value="">1</option>
          </select>
          <span>개월</span>
          <div class="flex-fill">
            <input type="text" class="form-control" placeholder="업력을 입력해주세요." />
          </div>
        </div>
      </div>
    </div>
    <!-- 업력 정보 -->
  </div>
</template>

<style scoped></style>
